import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Dropdown from '../../Dropdown';
import { isDropdownGroup } from '../../types';
import StandardMenu from '../StandardMenu';
import ArrowDownIcon from '../../../Icons/ArrowDown';
import { IconSize } from '../../../Icons/IconWrap';
import s from './StandardDropdown.scss';
var StandardDropdown = /** @class */ (function (_super) {
    __extends(StandardDropdown, _super);
    function StandardDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleToggle = function (isOpen) {
            _this.setState({ isOpen: isOpen });
        };
        _this.handleOnSelect = function (value, label) {
            if (_this.props.onSelect) {
                var selectedItem = StandardDropdown.getSelectedItem(value, _this.props.items);
                _this.setState({
                    selectedValue: value,
                    selectedLabel: label,
                    selectedIcon: selectedItem && selectedItem.icon,
                });
                _this.props.onSelect(value);
            }
        };
        return _this;
    }
    StandardDropdown.getDerivedStateFromProps = function (props, state) {
        if (!state || props.selectedValue !== state.prevSelectedValue) {
            var selectedItem = StandardDropdown.getSelectedItem(props.selectedValue, props.items) ||
                {};
            return {
                prevSelectedValue: props.selectedValue,
                selectedValue: StandardDropdown.getItemValue(selectedItem),
                selectedLabel: selectedItem.label,
                selectedIcon: selectedItem.icon,
            };
        }
        return null;
    };
    StandardDropdown.prototype.render = function () {
        var _a = this.props, items = _a.items, disabled = _a.disabled, arrowDown = _a.arrowDown, className = _a.className, usePortal = _a.usePortal, menuLabel = _a.menuLabel, placeholder = _a.placeholder, placeholderClassName = _a.placeholderClassName, menuAlignment = _a.menuAlignment, openClassName = _a.openClassName, itemClassName = _a.itemClassName, menuClassName = _a.menuClassName, menuScrollable = _a.menuScrollable, toggleClassName = _a.toggleClassName, menuLabelClassName = _a.menuLabelClassName, _b = _a.arrowSize, arrowSize = _b === void 0 ? IconSize.SMALL : _b, arrowClassName = _a.arrowClassName, withHoverEffect = _a.withHoverEffect, hideCheckIcon = _a.hideCheckIcon;
        var _c = this.state, selectedValue = _c.selectedValue, selectedLabel = _c.selectedLabel, selectedIcon = _c.selectedIcon, isOpen = _c.isOpen;
        var itemsWithSelectedProp = items.map(function (item) { return (__assign(__assign({}, item), { selected: StandardDropdown.getItemValue(item) === selectedValue })); });
        return (React.createElement(Dropdown, { className: classnames(s['root'], className), onToggle: this.handleToggle, onSelect: this.handleOnSelect, selectedValue: selectedValue, disabled: disabled, menuAlignment: menuAlignment, usePortal: usePortal },
            React.createElement(Dropdown.Toggle, { className: classnames(s['toggle'], toggleClassName, !selectedLabel && placeholderClassName, isOpen && openClassName), tabIndex: "-1" },
                selectedIcon || '',
                " ",
                selectedLabel || placeholder,
                ' ',
                arrowDown ? (arrowDown(classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open']))) : (React.createElement(ArrowDownIcon, { className: classnames(s['arrow-icon'], arrowClassName, isOpen && s['is-open']), size: arrowSize }))),
            React.createElement(StandardMenu, { className: classnames(s['menu'], menuAlignment === 'right' && s['align-right'], menuClassName), scrollable: menuScrollable, label: menuLabel, labelClassName: menuLabelClassName, items: itemsWithSelectedProp, itemClassName: classnames(s['menu-item'], itemClassName), hideCheckIcon: hideCheckIcon, withHoverEffect: withHoverEffect })));
    };
    StandardDropdown.getItemValue = function (item) {
        var option = item;
        return option.value !== undefined ? option.value : option.link;
    };
    StandardDropdown.getSelectedItem = function (value, items) {
        if (value !== undefined) {
            var flatItems_1 = [];
            items.forEach(function (item) {
                if (isDropdownGroup(item)) {
                    flatItems_1 = flatItems_1.concat(item.items);
                }
                else {
                    flatItems_1 = flatItems_1.concat([item]);
                }
            });
            return flatItems_1.find(function (item) { return StandardDropdown.getItemValue(item) === value; });
        }
        return false;
    };
    return StandardDropdown;
}(React.Component));
export default StandardDropdown;
//# sourceMappingURL=StandardDropdown.js.map